import React, { Component,Fragment } from 'react';
import Breadcrumb from "../../common/breadcrumb";
import { getCurrentAssignment, stopTimer, loadPostings, putToast, AuthenticatedUser, isAssignedRoom, setRoomAccepted, reviseTUser, reviseTUserAcceptRoom} from "../../api"
import RoundPostingCube from './cubes/posting/roundPostingCube';
import EventPostingCube from './cubes/posting/eventPostingCube';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from './tournamentPageTemplate'
import {Link} from 'react-router-dom';
import PageCloser from "../../common/pageCloser"
import Moment from 'react-moment';
import moment from 'moment';
import ModalWindow from "../../common/modalWindow"
import Modal from 'react-responsive-modal';

import Countdown from '../../common/countdown'

export class TournamentRoundPosting extends Component {
    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        const { user } = AuthenticatedUser();
        this.onRoomSelectClicked = this.onRoomSelectClicked.bind(this);
        this.onRoomSelectConfirmed = this.onRoomSelectConfirmed.bind(this);
        this.onRoomSelectCancel = this.onRoomSelectCancel.bind(this);
        this.onOpenSchedule = this.onOpenSchedule.bind(this);
        this.onCancelSchedule = this.onCancelSchedule.bind(this);
        
        this.state = {
            loading: true,
            open: false,
            openAccepted: false,
            openDeclined: false,
            user: user,
            pid: params.pid,
            tData: {},
            mode: 'round', 
            currentTitle: null,
            parents: []
        }
    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            loadPostings(this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                    this.setState({ loading: false});
                } else {
                    this.setState({ pid: pid, tData: d2.tournamentPage, tUser: d2.tUser, roomJson: JSON.parse(d2.tournamentPage.roomJson), loading: false});   
                    this.setMode();                 
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount(){
        this.loadTournamentPage();  
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params !== this.props.match.params) {
            this.setMode();
        }
    }

/**************** */

onOpenSchedule() {
    this.setState({open: true})
}

onCancelSchedule() {
    this.setState({open: false})
}

onRoomSelectClicked(hasAccepted, room) {
    this.setState({openAccepted: hasAccepted, openDeclined: !hasAccepted, tRoom: room})
}

onRoomSelectCancel() {
    this.setState({openAccepted: false, openDeclined: false })
}

onRoomSelectConfirmed() {
    const {tRound, tEvent, tRoom, openAccepted} = this.state;
    this.onTUserUpdate(tRound, tEvent, tRoom, openAccepted);
}

onTUserUpdate(round, event, room, preset) {
    const {tUser} = this.state;
    
    if (round) {
        var tUserRound = tUser.rounds.find(x=>x.roundId === round._id);            
        if (event) {
            var tUserRoundEvent = tUserRound.events.find(x=>x.eventId === event.eventId);                
            if (room) {
                var tUserRoundEventRoom = tUserRoundEvent.rooms.find(x=>x.roomId === room._id);
                setRoomAccepted(tUserRoundEventRoom, preset);
            } 
        }
    } 

    if (preset) {
        reviseTUserAcceptRoom(tUser).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Error - no data");
                putToast.error(d2 ? d2.error : "Error - no data");
                
                // since we did not succeed, we need to unassign this judge
                setRoomAccepted(tUserRoundEventRoom, false);
                reviseTUser(tUser); // update server with new status of tUser
                this.props.history.push(`/tournament/postings/${this.state.tData._id}/${round ? round._id : ''}`)

            } else {
                putToast.success(d2.message);
                this.props.history.push(`/tournament/room/${this.state.tData._id}/${room._id}`)
            }
        });   
        
    } else {

        reviseTUser(tUser).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Error - no data");
                putToast.error(d2 ? d2.error : "Error - no data");
            } else {
                putToast.success(d2.message);
                this.props.history.push(`/tournament/postings/${this.state.tData._id}/${round ? round._id : ''}`)
            }
        });   
    }    
    this.setState({ openAccepted: false, openDeclined: false })   

}

/**************** */


    setMode() {
        const {tData} = this.state;

        const { match: { params } } = this.props;
        const {roundId, eventId, roomId} = params;

        if (roundId && eventId && roomId) {
            const round = this.state.tData.rounds.find(x=>x._id === params.roundId);
            const event = round.events.find(x=>x._id === params.eventId);
            const room = event.rooms.find(x=>x._id === params.roomId);

            this.setState({
                mode: 'competitors', 
                tRound: round,
                tEvent: event,
                tRoom: room,
                currentTitle: room.title,
                parents: [ {
                    url: `${process.env.PUBLIC_URL}/tournament/postings/${tData._id}/${round._id}`,
                    name: round.title
                },{
                    url: `${process.env.PUBLIC_URL}/tournament/postings/${tData._id}/${round._id}/${event._id}/`,
                    name: event.title
                }]
            })
            return;
        }

        if (roundId && eventId) {
            const round = this.state.tData.rounds.find(x=>x._id === params.roundId);
            const event = round.events.find(x=>x._id === params.eventId);

            this.setState({
                mode: 'room', 
                tRound: round,
                tEvent: event,
                tRoom: null,
                currentTitle: event.title,
                parents: [ {
                    url: `${process.env.PUBLIC_URL}/tournament/postings/${tData._id}/${round._id}`,
                    name: round.title
                }]
            })
            return;
        }

        if (roundId) {
            const round = this.state.tData.rounds.find(x=>x._id === params.roundId);

            this.setState({
                mode: 'event', 
                tRound: round,
                tEvent: null,
                tRoom: null,
                currentTitle: round.title,
                parents: [ ]            
            })
            return;
        }

        this.setState({
            mode: 'round', 
            tRound: null,
            tEvent: null,
            tRoom: null,
            currentTitle: null,
            parents: []
        })
    }

    onRoundCubeTitleClicked(round) {
        this.props.history.push(`/tournament/postings/${this.state.tData._id}/${round._id}`)
    }

    onEventCubeTitleClicked(event) {
        this.props.history.push(`/tournament/postings/${this.state.tData._id}/${this.state.tRound._id}/${event._id}`)
    }

    onRoomCubeTitleClicked(room) {
        this.props.history.push(`/tournament/postings/${this.state.tData._id}/${this.state.tRound._id}/${this.state.tEvent._id}/${room._id}`)
    }

    renderModeSwitch() {
        const {mode, tData, tRound, tEvent, user, tUser } = this.state;
        const roomIds = mode === 'room' ? tEvent.rooms.filter(x=>isAssignedRoom(tUser, tRound, tEvent, x)).map(y=>y._id) : [];

        const reservedDate = tRound ? moment(tRound.startDate).add(-10, 'minute') : null;

        switch(mode) {
            case 'round': return  (
                <>
                    {tData.rounds.filter(x=>x.status === 'posted' || (tUser.isJudge && x.status === 'released') ).map((round, index) => {
                    return (
                    <div key={index} className="col-xl-4 col-md-6">
                        <RoundPostingCube key={index} 
                            onTitleClick={() => this.onRoundCubeTitleClicked(round)} 
                            tournament={tData} round={round} tUser={tUser} user={user} bg="bg-warning"
                        />
                    </div>
                    )})}
                </> )

            case 'event': return (
                <>
                    {tRound.events.map((event, index) => 
                    <div key={index} className="col-xl-4 col-md-6">
                        <EventPostingCube key={index} 
                            onTitleClick={() => this.onEventCubeTitleClicked(event)} 
                            tournament={tData} round={tRound} event={event} tUser={tUser} user={user} bg="bg-warning"
                        />
                    </div>
                    )}
                </> )

            case 'room': return (
                    <>
                    {tEvent.rooms.length
                    ? <>                
                        {tEvent.rooms.map((room, index) => { 
                        const records = room.competitors.map(x=>{ return {userId: x.userId, displayname: x.displayname, role: x.role, timeSlot: x.timeSlot}})
                        const acceptable =  (tRound.status === 'posted'  || tRound.status === 'released') && 
                                            roomIds.includes(room._id) && 
                                            !getCurrentAssignment(tUser) && 
                                            room.judges.length < tEvent.requiredJudgeCount

                        var reservedMet = true;
                        for(const id of room.reserved) { if (!room.judges.find(x=>x.userId === id)) {reservedMet = false; }}

                        const reserved = moment(new Date()).isBefore(reservedDate) && 
                                         !room.reserved.includes(tUser.userId) && 
                                         tEvent.requiredJudgeCount <= room.reserved.length + room.judges.length && 
                                         !reservedMet
                                         

                        return (
                        <div className="col-sm-12 blog-detail">
                            <div className="row">
                                <div className="col-12 blog-detail">
                                    {room.title !== "BYE"
                                    ?   <>
                                        <Link to={`/tournament/room/${tData._id}/${room._id}`}>
                                            <button style={{margin: "8px"}} type="button" className="btn btn-info"><i className="fa fa-desktop"></i>&nbsp;{room.title}</button>
                                        </Link>
                                        {acceptable && !reserved && 
                                        <button type="button" className="btn btn-primary" onClick={() => this.onRoomSelectClicked(true, room)} style={{margin: "8px"}}>Accept Assignment</button>
                                        }
                                        {acceptable && reserved && 
                                        <button type="button" className="btn btn-primary"  style={{margin: "8px", display: "inline-block"}}>Reserved: <Countdown tiny date={new Date(reservedDate)} /></button>
                                        }  
                                        </>                                      
                                    :   <button style={{margin: "8px"}}type="button" className="btn btn-info"><i className="fa fa-desktop"></i>&nbsp;{room.title}</button>

                                    }
                                </div>                                    
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <ReactTable
                                        data={records}
                                        columns={[{
                                            Header: 'Competitor',
                                            accessor: 'displayname',
                                            maxWidth: 300,
                                            Cell: (row) => (
                                                <span>{`${row.original.displayname} (${row.original.role})`}</span>
                                            )
                                        },{
                                            Header: 'Start Time',
                                            accessor: 'timeSlot', // String-based value accessors!
                                            maxWidth: 150,
                                            Cell: (prop) => (
                                                tData.useSpeechTimeslots ? (
                                                <Moment format="LT">{prop.value}</Moment>
                                                ) : (
                                                    'Any Available Time'
                                                )
                                            )
                                        }]}                                        
                                        defaultPageSize={records.length}
                                        showPagination={false}                                        
                                    />
                                </div>
                            </div>
                            <div className="row" style={{marginTop: "8px"}}>
                                <div className="col-12">
                                    <strong>Judging:</strong> {room.judges.map(x=>x.displayname).join(", ")}
                                </div>                                    
                            </div>
                            <br />
                            <br />
                        </div>
                        )}
                        )}

                    </> : 
                        <PageCloser 
                            header="No Rooms for this event"
                            message="Either this round has not yet been posted, or this event had no competitors for this round."
                        />
                    }
                </>)

            default: return null; 
        }
    }

    render() {
        if (this.state.loading) { return null; }

        stopTimer();
        const {tData, tRound, user, currentTitle, parents, roomJson, tUser} = this.state;

        const localRoot = {
            url: `${process.env.PUBLIC_URL}/tournament/postings/${tData._id}`,
            name: "Rounds"
        }

        //var currentRound = tState.currentTRoundId ? tData.rounds.find(x=>x._id === tState.currentTRoundId) : {title: "No rounds are currently active - Check back soon"};
        const isAnnouncing = tData.rounds.find(x=>x.isAnnouncing);
        const announcementRoom = roomJson ? roomJson.find(x=>x.tags.includes('announcements')) : null;
        const activeZoomButton = <button style={{marginBottom: "8px"}}type="button" className="btn btn-info"><i className="fa fa-film"></i>&nbsp;Video Room</button>

        const mySchedule = [];
        if (this.state.open) {
            for(const trEvent of tRound.events) {
                for(const treRoom of trEvent.rooms) {
                    const comp = treRoom.competitors.find(x=>x.userId === tUser.userId)
                    if (comp) {
                        mySchedule.push({
                            startDate: comp.timeSlot,
                            room: treRoom.title,
                            link: treRoom.videoLink,
                            event: trEvent.title
                        })
                    }
                }
            }
        }

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user}  
                bcTitle="Postings" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]} 
                title2={<>                    
                {`Postings - `}
                {(tUser.isCompetitor && tRound && tRound.status === 'posted') && <button type="button" className="btn btn-secondary" onClick={this.onOpenSchedule}>My Round Schedule</button>}
                </>}
            >
                <Fragment>
                    {isAnnouncing &&
                        <PageCloser 
                            header="Hope your tournament is going splendidly!"
                            message={<>The next round is being <strong>announced</strong> in the Announcements Room.  <p style={{fontSize: "28px"}}>Go there now by clicking <a target='_blank' rel="noopener noreferrer" href={announcementRoom.link}>here</a>.</p></>}
                            symbol="fa fa-bullhorn"
                        />                         
                    }
                    
                    {tData.rounds.filter(x=>x.status === 'posted' || (tUser.isJudge && x.status === 'released')).length
                    ? <>
                    <Breadcrumb localRoot={localRoot} title={currentTitle} parents={parents}/>
                    <div className="container-fluid">                
                        <div className="row">
                            {this.renderModeSwitch()}                                                                                      
                        </div>
                    </div>
                    </>
                    :
                    <PageCloser 
                        header="The next round has not been posted yet."
                        symbol="fa fa-info"
                    />
                    }
                    <ModalWindow title="Confirm Assignment ..." open={this.state.openAccepted} onCancel={this.onRoomSelectCancel}
                        content="Are you sure you want to accept this assignment?  Once you select 'Yes', the assignment is final and the room will be activated.  This cannot be undone. Once you click 'Yes', you will be taken to the tournament room."
                        commands={[
                            {title: "Yes", handler: this.onRoomSelectConfirmed}
                        ]}
                    />
                    <ModalWindow title="Confirm Decline ..." open={this.state.openDeclined} onCancel={this.onRoomSelectCancel}
                        content="Are you sure you want to decline this assignment?  Once you select 'Yes', you will be marked unavailable for this room."
                        commands={[
                            {title: "Yes", handler: this.onRoomSelectConfirmed}
                        ]}
                    />  
                       
                    <Modal open={this.state.open} onClose={this.onCancelSchedule} >
                        <div className="modal-header">
                            <h4 className="modal-title">My Round Schedule</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="card" >
                                    <div className="card-body" style={{padding: "0px"}}>
                                        {mySchedule.sort((a,b) => {return (b.startDate > a.startDate ? -1:1)}).map(x => {
                                        return (
                                        <div className="row">
                                            <div className="col-12">
                                                <h3>{x.event}</h3>
                                                <div className="row">
                                                    <div className="col-3">
                                                        <p>{ moment(x.startDate).format("LT")}</p>
                                                    </div>
                                                    <div className="col-3">
                                                        <p>{x.room}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <a target="_blank" rel="noopener noreferrer" href={x.link}>{activeZoomButton}</a>
                                                    </div>
                                                </div> 
                                                <div className="row">
                                                    <div className="col-3">
                                                    &nbsp;
                                                    </div>
                                                </div>                                   
                                            </div>
                                        </div>
                                        )})}
                                    </div>
                                </div>        
                            </div>
                        </div>
                        <div className="modal-footer">              
                        <button type="button" className="btn btn-primary" onClick={this.onCancelSchedule}>Cancel</button>
                        </div>
                    </Modal>


                </Fragment>
            </TournamentPageTemplate>
        )
    }
}

export default TournamentRoundPosting
